import type { FC } from "react";
import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";
import { StyledRadioButton } from "app/components/React/RadioSelect/styledComponents";
import type { IconName } from "@similarweb/icons";

interface ISharingOption {
    isSelected: boolean;
    onClick: VoidFunction;
    iconName: IconName;
    title: string;
    subTitle: string;
    isDisabled: boolean;
}

const { carbon } = colorsPalettes;
const { setFontVariant } = mixins;

const Container = styled.div<{ isDisabled: boolean }>`
    display: flex;
    gap: 4px;
    cursor: pointer;
    align-items: flex-start;
    ${({ isDisabled }) =>
        isDisabled &&
        `
        opacity: 0.4;
        pointer-events: none;
            `}
`;

const Wrapper = styled.div<{ isDisabled: boolean }>`
    ${({ isDisabled }) => isDisabled && `cursor: not-allowed;`}
`;

const LabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const TitleContainer = styled.div`
    display: flex;
    gap: 6px;
`;
const Title = styled.div`
    ${setFontVariant("body1", carbon[500])}
`;
const Subtitle = styled.div`
    ${setFontVariant("body1", carbon[300])}
`;

const Icon = styled(SWReactIcons)`
    svg {
        path {
            fill: ${carbon[500]};
        }
    }
`;

export const SharingOption: FC<ISharingOption> = (props) => {
    const { isSelected, onClick, iconName, title, subTitle, isDisabled } = props;
    return (
        <Wrapper isDisabled={isDisabled}>
            <Container
                onClick={onClick}
                isDisabled={isDisabled}
            >
                <StyledRadioButton
                    itemSelected={isSelected}
                    onClick={onClick}
                />
                <LabelContainer>
                    <TitleContainer>
                        <Icon
                            iconName={iconName}
                            size={"xs"}
                        />
                        <Title>{title}</Title>
                    </TitleContainer>
                    <Subtitle>{subTitle}</Subtitle>
                </LabelContainer>
            </Container>
        </Wrapper>
    );
};
